module.exports = __webpack_public_path__ + "static/media/photo_2018-03-05_01-20-47.3bc17b1c.jpg";